import type { RecordStepperStore } from "~/components/recordStepper/recordStepperTypes";

import { createContext } from "react";

const RecordStepperContext = createContext<null | RecordStepperStore>(null);

export default RecordStepperContext;
